import React from 'react';

const MobileMinute7 = () => (
    <div>
        <div className="sectionQuestion">Can I use Minute7 on my mobile phone?</div>
        <div className="sectionAnswer">
            Absolutely! We have a native app for both Android and iOS
            <div className="appStoreButtonsContainer">
                <a
                    href="https://itunes.apple.com/us/app/minute7/id812540141?ls=1&mt=8"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        className="helpAppStoreButton"
                        src="/appstore_btn.png"
                        alt="Apple AppStore"
                    />
                </a>
                <a
                    href="https://play.google.com/store/apps/details?id=com.minute7.mobile"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        className="helpAppStoreButton"
                        src="google_play_store_btn.png"
                        alt="Google Play Store"
                    />
                </a>
            </div>
        </div>
    </div>
);

export default MobileMinute7;
